import axios from "../api/axios";
import useAuth from "./useAuth";
import { useNavigate } from 'react-router'
import useAxiosPrivate from "./useAxiosPrivate";

const useLogout = () => {
  const { setAuth, updateAccessToken, updateWebSocketToken } = useAuth();
  const api = useAxiosPrivate()

  const logout = async () => {
    await api.get({endpoint:"/logout", mount: null});
    updateAccessToken(null);
    updateWebSocketToken(null);
    setTimeout(() => setAuth?.(undefined))
  }
  return logout;
}

export default useLogout